import { useEffect, useState } from 'react';
import { fetchData } from "../fetchData";
import { getLatestUserCookie } from '../../components/Login/user_session';
import { get } from '../../utils';
import { useSitecoreContext } from '../../utils/SitecoreContextReactContext';
function useProfile() {
  const sitecoreContext = useSitecoreContext();
  const apiGlobal = get(sitecoreContext, 'configuration.globalApi.apiGlobal') || 'https://apiqa.testvisitdubai.com';
  const identityGlobal = get(sitecoreContext, 'configuration.globalApi.identityGlobal') || 'https://replaceidentityGlobal';
  const clientId = get(sitecoreContext, 'configuration.globalApi.clientId') || 'replaceint2';
  const clientSecret = get(sitecoreContext, 'configuration.globalApi.clientSecret') || 'replacesecret';
  const [userProfile, setUserProfile] = useState();
  useEffect(() => {
    getLatestUserCookie(identityGlobal, clientId, clientSecret).then(userCookie => {
      if (userCookie.login_status && !userCookie.error) {
        fetchData({
          path: `${apiGlobal}/graphql/user`,
          options: {
            method: 'POST',
            body: JSON.stringify({
              query: `{ userProfile { firstName, lastName, email, country } }`
            })
          },
          authToken: userCookie.access_token
        }).then(data => {
          if (data.data.userProfile) {
            const {
              firstName,
              lastName,
              email
            } = data.data.userProfile;
            setUserProfile({
              firstName,
              lastName,
              email
            });
          }
        });
      }
    });
  }, []);
  return userProfile;
}
export default useProfile;